import { Routes } from '@angular/router';

import { permissionsGuard } from '../shared/services/guards/permission.guard';
import {
  getHomeDetailsResolver,
  getHomeListResolver,
} from '../shared/services/resolvers/get-home.resolver';
import { EmptyPageComponent } from './empty-page/empty-page.component';
import { DeviceDetailsComponent } from './home/device-details/device-details.component';
import { HomeComponent } from './home/home.component';
import { MainComponent } from './main.component';
import { PollsRoutes } from './polls/polls.routes';
import { registrationRoutes } from './registration/registration.routes';
import { reportRoutes } from './report/report.routes';
import { UploadDocumentsComponent } from './upload-documents/upload-documents.component';

export const mainRoutes: Routes = [
  {
    path: '',
    loadComponent: () => MainComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        title: 'Home',
        canActivate: [permissionsGuard],
        data: {
          page: 'Home',
          returnUrl: 'main/empty-page',
          permission: 'sapore.survey.home.get',
        },
        resolve: {
          home: getHomeListResolver,
        },
        loadComponent: () => HomeComponent,
      },
      {
        path: 'home/device/:id',
        title: 'Detalhes do Dispositivo',
        resolve: {
          details: getHomeDetailsResolver,
        },
        loadComponent: () => DeviceDetailsComponent,
      },
      {
        path: 'registration',
        title: 'Cadastros',
        loadChildren: () => registrationRoutes,
      },
      {
        path: 'polls',
        title: 'Pesquisas',
        loadChildren: () => PollsRoutes,
      },
      {
        path: 'report',
        title: 'Relatórios',
        loadChildren: () => reportRoutes,
      },
      {
        path: 'empty-page',
        title: 'Empty page',
        loadComponent: () => EmptyPageComponent,
      },
      {
        path: 'upload-documents',
        title: 'Upload de Documentos',
        loadComponent: () => UploadDocumentsComponent,
      },
    ],
  },
];
